
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FeatureStageItem } from './FeatureStageItem';
import FeatureSlider from './FeatureSlider.vue';
export default ComponentInitializeDispatcher.extend({
  name: 'owc-feature-stage-slider',
  props: {
    stageSliderData: {
      type: Object,
    },
  },
  components: { FeatureSlider },
  computed: {
    isDarkMode: function(): boolean {
      return Boolean(this.stageSliderData?.darkMode);
    },
    featureStageItems(): FeatureStageItem[] {
      return this.stageSliderData?.featuredItems || [];
    },
  },
});
